import { render, staticRenderFns } from "./ImportantOldList.vue?vue&type=template&id=932c6c0a&scoped=true&"
import script from "./ImportantOldList.vue?vue&type=script&lang=ts&"
export * from "./ImportantOldList.vue?vue&type=script&lang=ts&"
import style0 from "./ImportantOldList.vue?vue&type=style&index=0&id=932c6c0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932c6c0a",
  null
  
)

export default component.exports